import UsersEntity from '@/entities/api/users/users'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface UsersSlice {
	users: UsersEntity[]
	selectUser: UsersEntity | null
}

const initialState: UsersSlice = {
	users: [],
	selectUser: null,
}

const usersSlice = createSlice({
	name: 'users',
	initialState,
	reducers: {
		setUsersFn: (state, action: PayloadAction<UsersEntity[]>) => {
			state.users = action.payload
		},
		setSelectUserFn: (state, action: PayloadAction<UsersEntity>) => {
			state.selectUser = action.payload
		},
		addUserFn: (state, action: PayloadAction<UsersEntity>) => {
			state.users.push(action.payload)
		},
		updateUserFn: (state, action: PayloadAction<UsersEntity>) => {
			const index = state.users.findIndex(
				(user) => user._id === action.payload._id
			)
			if (index !== -1) {
				state.users[index] = action.payload
			}
		},
		deleteUserFn: (state, action: PayloadAction<string>) => {
			state.users = state.users.filter((user) => user._id !== action.payload)
		},
	},
})

export const {
	setSelectUserFn,
	setUsersFn,
	addUserFn,
	updateUserFn,
	deleteUserFn,
} = usersSlice.actions

export default usersSlice.reducer
